var exports = {
  "j": "OverlaysTab.module__buttonsWrapper___dVd3ZU",
  "F": "OverlaysTab.module__demoArea___dVd3ZU",
};

module.exports = exports;
